var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title-container"},[_c('div',{staticClass:"title-wrapper"},[_c('div',{staticClass:"title-text"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subtitle))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }